import restUtils from "core/utils/rest";
import { EntityType, entityTypeTransformer, investorDetailTransformer } from "./transformers/investor";


export const getInvestorDetails = (id: string) => {
  const url = `hubwise-api/aml/subject/${id}`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response;
  });
};

export const getEntityTypes = (): Promise<EntityType[]> => {
  const url = "hubwise-api/system/configuration/entity-types";
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map(entityTypeTransformer);
  });
};
